import { useState } from "react";
import SignupFullForm from "../../components/Pages/Coaches/Signup/SignupFullForm";
import ContactSuccess from "../../components/Pages/ContactSuccess";
import Head from "next/head";
import { useAppContext } from "../../_context";

const CoachesSignup = () => {
  const [{ tx }] = useAppContext();
  const [messageSent, setMessageSent] = useState(false);

  return (
    <>
      <Head>
        <title>RacketPal - {tx["Sign up"]}</title>
      </Head>
      {messageSent ? (
        <ContactSuccess />
      ) : (
        <SignupFullForm setMessageSent={setMessageSent} />
      )}
    </>
  );
};

export default CoachesSignup;
